import { render, staticRenderFns } from "./ConversationList.vue?vue&type=template&id=c49b5812&scoped=true&"
import script from "./ConversationList.vue?vue&type=script&lang=js&"
export * from "./ConversationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49b5812",
  null
  
)

export default component.exports